import { useState } from "react";
import taskController from "../../../../apis/Controllers/TaskController/task.controller";
import { useLocation, useNavigate } from "react-router-dom";
import Validation from "../../../Helper/validations/vaildation";
import commentsController from "../../../../apis/Controllers/CommentsController/comments.controler";
import { Toaster } from "../../../Helper/toaster/Toaster";


const TaskDetailFunctions = () => {
    const [taskData, setTaskData] = useState(null);
    const [loader, setLoader] = useState(false);
    const defaultValues = {
        comment: "",
    };

    const defaultErrors = {
        comment: {
            rules: ["required"],
            isValid: true,
            message: "",
        },
    };

    const [values, setValues] = useState(defaultValues);
    const [isError, setError] = useState(defaultErrors);
    const [showAssignedModal, setShowAssignedModal] = useState(false);
    const loaction = useLocation();
    let navigate = useNavigate();


    const getTaskDetail = async (id) => {
        setLoader(true);
        let response = await taskController.taskDetail(id);
        if (response && response.status) {
            setTaskData(response.data);
            setLoader(false);
        }
        else {
            setTaskData(null);
            setLoader(false);
        }
    };


    const handleChange = (field, value) => {
        let validation = new Validation(isError);
        let node = validation.validateField(field, value);
        setError({ ...isError, [field]: node });
        setValues({ ...values, [field]: value });
    };


    const handleSubmitComment = async () => {
        let validation = new Validation(isError);
        let isValid = validation.isFormValid(values);
        if (isValid && !isValid.haveError) {
            setLoader(true);
            let response = await commentsController.commentsCreate(taskData, values.comment);
            if (response && response.status) {
                let id = loaction && loaction.state && loaction.state.id
                getTaskDetail(id);
                setValues(defaultValues);
                new Toaster().success(response.message);
                setLoader(false);
            } else {
                new Toaster().error(response.error);
                setLoader(false);
            }
        } else {
            setError({ ...isValid.errors });
        }
    };


    const handleTaskCompleted = async () => {
        setLoader(true);
        let id = taskData && taskData.id ? taskData.id : ''
        let response = await taskController.taskComplete(id);
        if (response && response.status) {
            new Toaster().success(response.message);
            setLoader(false);
            getTaskDetail(id);
        }
        else {
            new Toaster().error(response.error);
            setLoader(false);
        }
    };


    return {
        getTaskDetail,
        taskData,
        loader,
        loaction,
        navigate,
        values,
        setValues,
        isError,
        setError,
        handleSubmitComment,
        handleChange,
        defaultValues,
        handleTaskCompleted,
        showAssignedModal, 
        setShowAssignedModal
    }
};


export default TaskDetailFunctions;